import moment from 'moment';
import { getFromPage } from '@laigu/component/business/conv-source';
import { message } from 'antd';
import removeHTMLTag from '../removeHTMLTag';
import initVisitor from '../init-visitor';

const createImage = options => {
  options = options || {};
  const img = document.createElement('img');
  if (options.src) {
    img.src = options.src;
  }
  return img;
};

const copyToClipboard = async blob => {
  try {
    await navigator.clipboard.write([
      new window.ClipboardItem({
        [blob.type]: blob
      })
    ]);
  } catch (error) {
    console.error(error);
  }
};

const convertToPng = imgBlob => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const imageEl = createImage({ src: window.URL.createObjectURL(imgBlob) });
  imageEl.onload = e => {
    canvas.width = e.target.width;
    canvas.height = e.target.height;
    ctx.drawImage(e.target, 0, 0, e.target.width, e.target.height);
    canvas.toBlob(copyToClipboard, 'image/png', 1);
  };
};

export const copyText = text => {
  const blob = new Blob([text], { type: 'text/plain' });
  copyToClipboard(blob);
};

// 当前活跃 WorkCenter 的消息流引用，替代旧的 sessionStorage 全局中转
// 避免大会话 JSON.stringify 后超出 sessionStorage 配额导致白屏
let currentConvStreams = null;

export const setConvStreams = streams => {
  currentConvStreams = streams;
};

/*
 * 首先判断当前消息是事件还是内容
 * 总结和折叠消息不走判断
 * 消息类型
 *  1. 事件
 *    1.1 会话初始化【需要区分是复制对话内容和对话的情况】
 *  2. 普通消息
 */
export const copyConvToClipboard = (filterInit = false, streamsArg) => {
  const streams = streamsArg ?? currentConvStreams;

  if (streams) {
    let str = '';

    if (streams.length) {
      const hasSummaryEventType = [
        'switch_human',
        'end_conv_timeout',
        'end_conv_agent',
        'end_conv_baidu_robot',
        'end_conv_client'
      ];

      for (let stream of streams) {
        let firstline = '';
        let secondline = '';

        const {
          action,
          type,
          children,
          content_type = 'event',
          media_url = '',
          created_on,
          from_type,
          agent,
          content = '',
          body = {}
        } = stream;
        if (hasSummaryEventType.includes(action) || (type === 'fold' && children.length)) {
        } else {
          switch (content_type) {
            case 'text':
            case 'photo':
            case 'file':
            case 'audio':
            case 'video':
              const username =
                from_type === 'agent' ? (agent ? agent.realname : '客服') : from_type === 'bot' ? '客服' : '顾客';
              const created_time = moment
                .utc(created_on)
                .local()
                .format('MM-DD HH:mm:ss');

              firstline = `${created_time} ${username}`;

              if (content_type === 'text') {
                secondline = content;
              } else {
                secondline = media_url;
              }
              break;
            case 'bot':
              const created_time_bot = moment
                .utc(created_on)
                .local()
                .format('MM-DD HH:mm:ss');

              firstline = `${created_time_bot} 机器人客服`;

              secondline = content;
              break;
            case 'rich_text':
              const created_time_rich = moment
                .utc(created_on)
                .local()
                .format('MM-DD HH:mm:ss');

              firstline = `${created_time_rich} 客服`;

              secondline = removeHTMLTag(content);
              break;
            case 'event':
              switch (action) {
                case 'init_conv':
                  if (filterInit) break;
                  const { url: convUrl, title: convTitle, visit_info } = body;

                  const visitInfo = initVisitor(visit_info);

                  const {
                    first_visit_page_url_by_session: firstVisitUrl,
                    first_visit_page_title_by_session: firstVisitTitle,
                    first_visit_page_source_url_by_session: firstVisitSource
                  } = visitInfo;

                  if (!firstVisitSource && !convUrl && !firstVisitUrl) {
                    break;
                  }

                  const pages = [
                    getFromPage(visitInfo),
                    {
                      label: '着陆页',
                      url: firstVisitUrl ?? '',
                      title: firstVisitTitle ?? ''
                    },
                    {
                      label: '对话页',
                      url: convUrl ?? '',
                      title: convTitle ?? ''
                    }
                  ];

                  pages.forEach((page, index) => {
                    let line =
                      !page || (page.url === '' && page.title === '')
                        ? ''
                        : `${page.label} ${page.title}` + '\r\n' + page.url + '\r\n';

                    firstline += line + (index !== pages.length ? '\r\n' : '');
                  });

                  break;
                default:
                  break;
              }
              break;
            default:
              break;
          }

          firstline = (firstline.length ? firstline + '\r\n' : '') + (secondline.length ? secondline + '\r\n\r\n' : '');
        }
        str += firstline;
      }
    }
    const copyArea = document.createElement('textarea');
    copyArea.value = str;
    document.body.appendChild(copyArea);
    copyArea.select();
    try {
      copyArea.focus();
      copyArea.setSelectionRange(0, -1);
      document.execCommand('copy');
      document.body.removeChild(copyArea);
      message.success('复制成功');
    } catch (err) {
      message.error('复制失败');
      document.body.removeChild(copyArea);
    }
  }
};
